import React from "react";
import bodyHelperTypes from "../../../utils/BodyHelperTypes";
import UnorderedList from "../../../layouts/bodyLayouts/helpers/UnorderedList";
import Links from "../../../components/Links";

const sOCA_Content = [

    // {
    //     format: bodyHelperTypes.title,
    //     order: 10,
    //     content: "Presented by the Department for Behavioral Health, Developmental and Intellectual Disabilities"
    // },
    {
        format: bodyHelperTypes.paragraphs,
        order: 10,
        content: [
            <>The System of Care (SOC) Academy is convened annually by the Department for Behavioral Health, Developmental & Intellectual Disabilities (DBHDID) and partners. In 2024, the SOC Academy celebrated its 10th anniversary with a virtual event hosted by DBHDID and Mental Health America of Kentucky.
            </>,
            <>
                Each year, DBHDID convenes the SOC Academy to strengthen Kentucky’s system of care (see Related Links) for children, transition-age youth, and their families.  Since 2014, the Academy has prioritized themes such as promoting equity; reducing health disparities; collaboration among interagency state and community partners; prevention, early intervention, and treatment; building resilient youth, families and communities; and KY’s response to the opioid epidemic.

            </>,
            <>
              Continuing the tradition established in 2020, the 2025 SOC Academy will once again be hosted as a virtual event to reach a broader audience and provide expanded access to valuable content. Looking ahead, the DBHDID is excited to announce that the 2026 SOC Academy will return to an in-person event designed to foster meaningful connections, provide dedicated time for professional development, and offer collaborative learning. Attendees will have the opportunity to engage with subject matter experts, connect with peers, and enhance professional skills in a face-to-face setting.
            </>,
            <>The SOC Academy serves a diverse audience that includes advocates, clinicians, case managers, prevention specialists, peer support specialists, educators, faith-based leaders, psychologist/psychiatrists, child care providers, families and youth with lived mental health experience, and staff from Family Resource and Youth Services Centers, juvenile justice, family and juvenile services, community-based services, child welfare, and public health, as well as interested community members, and more.</>,


            // <>To learn more about System of Care core values and guiding principles, see the <b>Evolution of the SOC Approach 2021</b> in Related Links.</>,

            <>Continuing education units will be available pending licensure board approvals. American Sign Language (ASL) Interpreters and Communication Access Realtime Translation (CART) will be available upon request. </>,

            // <>Find 2022-2023 recorded sessions by clicking “SOC Learning Series Recordings ” under Related Links. The Department is unable to offer certificates for viewing the recordings.</>,

            <>To request more information, click on the "Contact Us" link in the Contact Information box.
                <br />
            </>

        ]
    },







];

export default sOCA_Content;